import { ref, set, child, get, onValue } from "firebase/database";
import { db, defaultNudgeDb, testDb } from "../../firebase";
import { OPTIONS, allPersonaTypes, userPersonaTypes } from "../../constant/nudgeOptions";
import handleToast from "../Toast";
import { handleSaveReturningNudge } from "./handleSaveReturningNudge";
import { handleSaveBannerInHtmlNudge } from "./handleSaveBannerInHtmlNudge"

// ! NEED TO CHANGE testDb to db and testuser-prod to user in production

// things to keep in mind:
// 1: add the default properties of all nudges to dailyEmails database(we have used it for storing the default properties of all nudges))
// 2: handleSaveDefaultToDb() function is used to set the default nudge to the database
// 3: handleSaveFirstTimeNudge() function is used to save the customized First time nudge to the database
// 4: *create other function to save the other nudge to the database

// TODO: need to fix the real time update of the nudgeData
function getNudgeData(
  user,
  setUsersNudgeData,
  setUserPersonaTypes,
  setAllPersonaTypes,
  setAvailablePersonaTypes
) {
  return new Promise((resolve, reject) => {
    try {
      //  use commented code for production
      const dbRef = ref(db, `${user}/customise_nudge`);
      // const dbRef = ref(testDb, `testuser-prod/customise_nudge`);
      onValue(dbRef, async (snapshot) => {

        if (snapshot.exists()) {
          //allPersonaTypesDb will come from:
          let allPersonaTypesDB = [];
          const personaTypesSnapshot = await get(
            child(ref(defaultNudgeDb), `dashboard-prod/allPersonaTypes`)
            // child(ref(db), `${user}/allPersonaTypes`)
          );
          if (personaTypesSnapshot.exists()) {
            allPersonaTypesDB = personaTypesSnapshot.val();
            allPersonaTypesDB = allPersonaTypesDB.filter(item => item);
          }

          // console.log("---------- snapshot.val()--------", snapshot.val());
          let { userNudgeData, userPersonaTypes } = snapshot.val();
          // check if userNudgeData is empty
          //! DELETE below if-block temporarily handling (userNudgeData===undefined){}
          // if (userNudgeData === undefined) {
          //   userNudgeData:  snapshot.val()
          // }

          // console.log("userNudgeData, userPersonaTypes", userNudgeData, userPersonaTypes)
          userPersonaTypes = userPersonaTypes
            ? userPersonaTypes
            : [
                {
                  optionName: "First Time",
                  optionValue: "firstTimePersonaNudge",
                },
              ];
          // data structure of userNudgeData
          const result = {
            // userNudgeData:  snapshot.val(),
            userNudgeData: userNudgeData,
            userPersonaTypes: userPersonaTypes,
            allPersonaTypesDb: allPersonaTypesDB,
            availablePersonaTypes: [],
          };
          // const availablePersonaTypes = allPersonaTypesDB.filter(
          //   (item) =>
          //     !userPersonaTypes.some(
          //       (element) => element.optionValue === item.optionValue
          //     )
          // );
          // result.availablePersonaTypes = availablePersonaTypes;

          result.availablePersonaTypes = allPersonaTypesDB;

          // setting the here states so whenever there is a change in database it will update the states
          setUsersNudgeData(result.userNudgeData);
          setUserPersonaTypes(result.userPersonaTypes);
          setAllPersonaTypes(result.allPersonaTypesDb);
          setAvailablePersonaTypes(result.availablePersonaTypes);
          console.log("result", result);
          resolve(result);



        } else {

          console.log("No data available");

          // request to get the allPersonaTypes from the nudgeDb database
          let allPersonaTypesDB = [];
          const personaTypesSnapshot = await get(
            child(ref(defaultNudgeDb), `dashboard-prod/allPersonaTypes`)
            // child(ref(db), `${user}/allPersonaTypes`)
          );
          if (personaTypesSnapshot.exists()) {
            allPersonaTypesDB = personaTypesSnapshot.val();
            allPersonaTypesDB = allPersonaTypesDB.filter(item => item);
            console.log("allPersonaTypesDB", allPersonaTypesDB)
          }

          // request to get the userPersonaTypes from the nudgeDb database
          let userPersonaTypesDB = [];
          const userPersonaTypesSnapshot = await get(
            // child(ref(defaultNudgeDb), `dashboard-prod/userPersonaTypes`)
            child(ref(db), `${user}/userPersonaTypes`)
          );
          if (userPersonaTypesSnapshot.exists()) {
            userPersonaTypesDB = userPersonaTypesSnapshot.val();
            console.log("userPersonaTypesDB", userPersonaTypesDB)

          }

          // request to get the nudgesData from the nudgeDb database
          const nudgesData = await get(
            // child(ref(defaultNudgeDb), `dashboard-prod/customise_nudge`)
            child(ref(db), `${user}/customise_nudge`)
          );
          if (nudgesData.exists()) {
            const res = nudgesData.val();
            const result = {
              userNudgeData: res,
              userPersonaTypes: userPersonaTypesDB,
              allPersonaTypesDb: allPersonaTypesDB,
              availablePersonaTypes: [],
            };
            // const availablePersonaTypes = allPersonaTypesDB.filter(
            //   (item) =>
            //     !userPersonaTypesDB.some(
            //       (element) => element.optionValue === item.optionValue
            //     )
            // );
            // result.availablePersonaTypes = availablePersonaTypes;

            result.availablePersonaTypes = allPersonaTypesDB;


            // setting the here states so whenever there is a change in database it will update the states
            setUsersNudgeData(result.userNudgeData);
            setUserPersonaTypes(result.userPersonaTypes);
            setAllPersonaTypes(result.allPersonaTypesDb);
            setAvailablePersonaTypes(result.availablePersonaTypes);
            console.log("result", result)
            resolve(result);
          }
        }
      });
    } catch (error) {
      reject(error);
    }
  });
}






const handleSaveFirstTimeNudge = (
  nudgeData,
  customizeState,
  nudgePosition,
  user,
  nudgeName
) => {
  // state of first time nudge to
  let state = {
    nudgeOfferText: {
      ...nudgeData.nudgeOfferText,
      customizeProperties: {
        ...nudgeData.nudgeOfferText.customizeProperties,
        text: {
          ...nudgeData.nudgeOfferText.customizeProperties.text,
          propertyValue: customizeState.nudgeOfferText.text,
        },
        textColor: {
          ...nudgeData.nudgeOfferText.customizeProperties.textColor,
          propertyValue: customizeState.nudgeOfferText.textColor,
        },
        fontStyle: {
          ...nudgeData.nudgeOfferText.customizeProperties.fontStyle,
          propertyValue: customizeState.nudgeOfferText.fontStyle,
        },
        isExpiryTimer: {
          ...nudgeData.nudgeOfferText.customizeProperties.isExpiryTimer,
          propertyValue: customizeState.nudgeOfferText.isExpiryTimer,
        },
        minutes: {
          ...nudgeData.nudgeOfferText.customizeProperties.minutes,
          propertyValue: customizeState.nudgeOfferText.minutes,
        },
      },
    },
    nudgeCouponCode: {
      ...nudgeData.nudgeCouponCode,
      customizeProperties: {
        ...nudgeData.nudgeCouponCode.customizeProperties,
        text: {
          ...nudgeData.nudgeCouponCode.customizeProperties.text,
          propertyValue: customizeState.nudgeCouponCode.text,
        },
        textColor: {
          ...nudgeData.nudgeCouponCode.customizeProperties.textColor,
          propertyValue: customizeState.nudgeCouponCode.textColor,
        },
        backgroundColor: {
          ...nudgeData.nudgeCouponCode.customizeProperties.backgroundColor,
          propertyValue: customizeState.nudgeCouponCode.backgroundColor,
        },
        fontStyle: {
          ...nudgeData.nudgeCouponCode.customizeProperties.fontStyle,
          propertyValue: customizeState.nudgeCouponCode.fontStyle,
        },
        borderStyle: {
          ...nudgeData.nudgeCouponCode.customizeProperties.borderStyle,
          propertyValue: customizeState.nudgeCouponCode.borderStyle,
        },
        borderColor: {
          ...nudgeData.nudgeCouponCode.customizeProperties.borderColor,
          propertyValue: customizeState.nudgeCouponCode.borderColor,
        },
        borderWidth: {
          ...nudgeData.nudgeCouponCode.customizeProperties.borderWidth,
          propertyValue: customizeState.nudgeCouponCode.borderWidth,
        },
        borderRadius: {
          ...nudgeData.nudgeCouponCode.customizeProperties.borderRadius,
          propertyValue: customizeState.nudgeCouponCode.borderRadius,
        },
        display: {
          ...nudgeData.nudgeCouponCode.customizeProperties.display,
          propertyValue: customizeState.nudgeCouponCode.display,
        },
      },
    },
    nudgeCopyCode: {
      ...nudgeData.nudgeCopyCode,
      customizeProperties: {
        ...nudgeData.nudgeCopyCode.customizeProperties,
        text: {
          ...nudgeData.nudgeCopyCode.customizeProperties.text,
          propertyValue: customizeState.nudgeCopyCode.text,
        },
        textColor: {
          ...nudgeData.nudgeCopyCode.customizeProperties.textColor,
          propertyValue: customizeState.nudgeCopyCode.textColor,
        },
        backgroundColor: {
          ...nudgeData.nudgeCopyCode.customizeProperties.backgroundColor,
          propertyValue: customizeState.nudgeCopyCode.backgroundColor,
        },
        fontStyle: {
          ...nudgeData.nudgeCopyCode.customizeProperties.fontStyle,
          propertyValue: customizeState.nudgeCopyCode.fontStyle,
        },
        borderStyle: {
          ...nudgeData.nudgeCopyCode.customizeProperties.borderStyle,
          propertyValue: customizeState.nudgeCopyCode.borderStyle,
        },
        borderColor: {
          ...nudgeData.nudgeCopyCode.customizeProperties.borderColor,
          propertyValue: customizeState.nudgeCopyCode.borderColor,
        },
        borderWidth: {
          ...nudgeData.nudgeCopyCode.customizeProperties.borderWidth,
          propertyValue: customizeState.nudgeCopyCode.borderWidth,
        },
        borderRadius: {
          ...nudgeData.nudgeCopyCode.customizeProperties.borderRadius,
          propertyValue: customizeState.nudgeCopyCode.borderRadius,
        },
        ...(nudgeData.nudgeCopyCode.customizeProperties.href && {
          href: {
              ...nudgeData.nudgeCopyCode.customizeProperties.href,
              propertyValue: customizeState.nudgeCopyCode.href,
          }
      }),
      },
    },
    nudge: {
      ...nudgeData.nudge,
      customizeProperties: {
        ...nudgeData.nudge.customizeProperties,
        backgroundColor: {
          ...nudgeData.nudge.customizeProperties.backgroundColor,
          propertyValue: customizeState.nudge.backgroundColor,
        },
        borderColor: {
          ...nudgeData.nudge.customizeProperties.borderColor,
          propertyValue: customizeState.nudge.borderColor,
        },
        borderStyle: {
          ...nudgeData.nudge.customizeProperties.borderStyle,
          propertyValue: customizeState.nudge.borderStyle,
        },
        borderWidth: {
          ...nudgeData.nudge.customizeProperties.borderWidth,
          propertyValue: customizeState.nudge.borderWidth,
        },
        borderRadius: {
          ...nudgeData.nudge.customizeProperties.borderRadius,
          propertyValue: customizeState.nudge.borderRadius,
        },
      },
      nudgePosition: {
        ...nudgeData.nudge.nudgePosition,
        desktop: {
          ...nudgeData.nudge.nudgePosition.desktop,
          top: nudgePosition.desktop.top,
          left: nudgePosition.desktop.left,
        },
        mobile: {
          ...nudgeData.nudge.nudgePosition.mobile,
          top: nudgePosition.mobile.top,
        },
      },
    },
    nudgeShowing: {
      ...nudgeData.nudgeShowing,
      customizeProperties: {
        ...nudgeData.nudgeShowing.customizeProperties,
        allowed: {
          ...nudgeData.nudgeShowing.customizeProperties.allowed,
          propertyValue: (customizeState.nudgeShowing.allowed === undefined || customizeState.nudgeShowing.allowed.length === 0 || customizeState.nudgeShowing.allowed === "") ? [] : customizeState.nudgeShowing.allowed
        },
        prohibited: {
          ...nudgeData.nudgeShowing.customizeProperties.prohibited,
          propertyValue: customizeState.nudgeShowing.prohibited
        },
        status: {
          ...nudgeData.nudgeShowing.customizeProperties.status,
          propertyValue: customizeState.nudgeShowing.status
        }, 
        firstTimeNudgeShown: {
          ...nudgeData.nudgeShowing.customizeProperties.firstTimeNudgeShown,
          propertyValue: customizeState.nudgeShowing.firstTimeNudgeShown
        }, 
        sensitivity: {
          ...nudgeData.nudgeShowing.customizeProperties.sensitivity,
          propertyValue: customizeState.nudgeShowing.sensitivity,
        },
        device: {
          ...nudgeData.nudgeShowing.customizeProperties?.device,
          propertyValue: customizeState.nudgeShowing.device,
        },
        nudgeTimeout: {
          ...nudgeData.nudgeShowing.customizeProperties?.nudgeTimeout,
          propertyValue: customizeState.nudgeShowing.nudgeTimeout,
        },
        Geolocation: {
          ...nudgeData.nudgeShowing.customizeProperties.Geolocation,
          propertyValue: customizeState.nudgeShowing.Geolocation,
        },
        audience: {
          ...nudgeData.nudgeShowing.customizeProperties.audience,
          propertyValue: customizeState.nudgeShowing.audience,
        },
        ...(nudgeData.nudgeShowing.customizeProperties.endDate && {
          endDate: {
              ...nudgeData.nudgeShowing.customizeProperties.endDate,
              propertyValue: customizeState.nudgeShowing.endDate,
          },
      }),
        ...(nudgeData.nudgeShowing.customizeProperties.popupShown && {
          popupShown: {
              ...nudgeData.nudgeShowing.customizeProperties.popupShown,
              propertyValue: customizeState.nudgeShowing.popupShown,
          }
      }),
        ...(nudgeData.nudgeShowing.customizeProperties.priority && {
          priority: {
              ...nudgeData.nudgeShowing.customizeProperties.priority,
              propertyValue: customizeState.nudgeShowing.priority,
          }
        }),
        ...(nudgeData.nudgeShowing.customizeProperties.abandonedCart && {
          abandonedCart: {
              ...nudgeData.nudgeShowing.customizeProperties.abandonedCart,
              propertyValue: customizeState.nudgeShowing.abandonedCart,
          }
      }),
        ...(nudgeData.nudgeShowing.customizeProperties.nudgeActiveDays && {
          nudgeActiveDays: {
              ...nudgeData.nudgeShowing.customizeProperties.nudgeActiveDays,
              propertyValue: customizeState.nudgeShowing.nudgeActiveDays,
          },
      }),
      ...(nudgeData.nudgeShowing.customizeProperties.GeoZipcodes && {
          GeoZipcodes: {
              ...nudgeData.nudgeShowing.customizeProperties.GeoZipcodes,
              propertyValue: customizeState.nudgeShowing.GeoZipcodes,
          },
      }),
      ...(nudgeData.nudgeShowing.customizeProperties.seoKeyword && {
          seoKeyword: {
              ...nudgeData.nudgeShowing.customizeProperties.seoKeyword,
              propertyValue: customizeState.nudgeShowing.seoKeyword,
          },
      }),
      ...(nudgeData.nudgeShowing.customizeProperties.ipBasedNudgeControl && {
          ipBasedNudgeControl: {
              ...nudgeData.nudgeShowing.customizeProperties.ipBasedNudgeControl,
              propertyValue: customizeState.nudgeShowing.ipBasedNudgeControl,
          },
      }),
      ...(nudgeData.nudgeShowing.customizeProperties.firstTimeUserCheckingOptions && {
          firstTimeUserCheckingOptions: {
              ...nudgeData.nudgeShowing.customizeProperties.firstTimeUserCheckingOptions,
              propertyValue: customizeState.nudgeShowing.firstTimeUserCheckingOptions,
          },
      }),
        }
    },
    nudgePosition: {
      ...nudgeData.nudgePosition,
      customizeProperties: {
        ...nudgeData.nudgePosition.customizeProperties,
        margin_left: {
          ...nudgeData.nudgePosition.customizeProperties?.margin_left,
          propertyValue: customizeState.nudgePosition.margin_left,
        },
        margin_top: {
          ...nudgeData.nudgePosition.customizeProperties?.margin_top,
          propertyValue: customizeState.nudgePosition.margin_top,
        },
        margin_right: {
          ...nudgeData.nudgePosition.customizeProperties?.margin_right,
          propertyValue: customizeState.nudgePosition.margin_right,
        },
        margin_bottom: {
          ...nudgeData.nudgePosition.customizeProperties?.margin_bottom,
          propertyValue: customizeState.nudgePosition.margin_bottom,
        },
        placement: {
          ...nudgeData.nudgePosition.customizeProperties?.placement,
          propertyValue: customizeState.nudgePosition.placement,
        },
        }
    },
    nudgeClosed: {
      ...nudgeData.nudgeClosed,
      customizeProperties: {
        ...nudgeData.nudgeClosed.customizeProperties,
        fontSize: {
          ...nudgeData.nudgeClosed.customizeProperties.fontSize,
          propertyValue: customizeState.nudgeClosed.fontSize
        },
        textColor: {
          ...nudgeData.nudgeClosed.customizeProperties.textColor,
          propertyValue: customizeState.nudgeClosed.textColor
        }, 
        topPosition: {
          ...nudgeData.nudgeClosed.customizeProperties.topPosition,
          propertyValue: customizeState.nudgeClosed.topPosition
        }, 
        rightPosition: {
          ...nudgeData.nudgeClosed.customizeProperties.rightPosition,
          propertyValue: customizeState.nudgeClosed.rightPosition,
        }
      }
    },
    nudgeTrafficSources: {
      ...nudgeData?.nudgeTrafficSources,
      customizeProperties: {
        ...nudgeData?.nudgeTrafficSources?.customizeProperties,
        referrerSites: {
          ...nudgeData?.nudgeTrafficSources?.customizeProperties?.referrerSites,
          propertyValue: (customizeState?.nudgeTrafficSources?.referrerSites === undefined || customizeState?.nudgeTrafficSources?.referrerSites?.length === 0 || customizeState?.nudgeTrafficSources?.referrerSites === "") ? [] : customizeState?.nudgeTrafficSources?.referrerSites
        },
        queryParams: {
          ...nudgeData?.nudgeTrafficSources?.customizeProperties?.queryParams,
          propertyValue: (customizeState?.nudgeTrafficSources?.queryParams === undefined || customizeState?.nudgeTrafficSources?.queryParams?.length === 0 || customizeState?.nudgeTrafficSources?.queryParams === "") ? [] : customizeState?.nudgeTrafficSources?.queryParams
        },
        excludeReferrerSites: {
          ...nudgeData?.nudgeTrafficSources?.customizeProperties?.excludeReferrerSites,
          propertyValue: (customizeState?.nudgeTrafficSources?.excludeReferrerSites === undefined || customizeState?.nudgeTrafficSources?.excludeReferrerSites?.length === 0 || customizeState?.nudgeTrafficSources?.excludeReferrerSites === "") ? [] : customizeState?.nudgeTrafficSources?.excludeReferrerSites
        },
        }
    },
    ...(customizeState.nudgeDisclaimerText && {
      nudgeDisclaimerText: {
        ...nudgeData.nudgeDisclaimerText,
        customizeProperties: {
          ...nudgeData.nudgeDisclaimerText.customizeProperties,
          text: {
            ...nudgeData.nudgeDisclaimerText.customizeProperties.text,
            propertyValue: customizeState.nudgeDisclaimerText.text,
          },
          textColor: {
            ...nudgeData.nudgeDisclaimerText.customizeProperties.textColor,
            propertyValue: customizeState.nudgeDisclaimerText.textColor,
          },
          fontStyle: {
            ...nudgeData.nudgeDisclaimerText.customizeProperties.fontStyle,
            propertyValue: customizeState.nudgeDisclaimerText.fontStyle,
          },
          fontSize: {
            ...nudgeData.nudgeDisclaimerText.customizeProperties.fontSize,
            propertyValue: customizeState.nudgeDisclaimerText.fontSize,
          },
          display: {
            ...nudgeData.nudgeDisclaimerText.customizeProperties.display,
            propertyValue: customizeState.nudgeDisclaimerText.display,
          },
        },
      },
    }),
    }

    const getFirstMonday = () => {
      const now = new Date();
      const day = now.getDay();
      const distanceToMonday = (day + 6) % 7; 
      const firstMonday = new Date(now);
      firstMonday.setDate(now.getDate() - distanceToMonday);
      return firstMonday;
    };

    const formatDate = (date) => {
      const dd = String(date.getDate()).padStart(2, '0');
      const mm = String(date.getMonth() + 1).padStart(2, '0');
      const yyyy = date.getFullYear();
      return `${dd}-${mm}-${yyyy}`;
    };
  
    const firstMondayDate = getFirstMonday();
    const dateKey = formatDate(firstMondayDate);

    if (nudgeData.nudgeShowing.customizeProperties.status !== customizeState.nudgeShowing.status) {
      const timestamp = new Date().toISOString().replace(/[.#$/[\]]/g, "_");
      const formattedData = {
          timestamp: new Date().toISOString(),
          nudge_title: nudgeName,
          nudge_couponCode: customizeState.nudgeCouponCode.text,
          status: customizeState.nudgeShowing.status
      };
  
      const newLogRef = ref(db, `${user}/graph-cflogs/${dateKey}/${timestamp}`);
      set(newLogRef, formattedData)
          .then(() => {
              handleToast("success", "Saved Successfully!");
          })
          .catch((err) => {
              console.log(err);
              handleToast("error", "Failed to save nudge history!");
          });
  }
  
  

    console.log("handleSaveFirstTimeNudge -> state", state);

  set(
    // ref(testDb, `testuser-prod/customise_nudge/userNudgeData/${nudgeName}`),
    ref(db, `${user}/customise_nudge/userNudgeData/${nudgeName}`),
    state
  )
    .then(() => {
      handleToast("success", "Saved Successfully!");
    })
    .catch((err) => {
      console.log(err);
      handleToast("error", "Try after sometimes!");
    });
};


const NudgeModifiedTitle = (title) => {
  return title.replace(/\s*\d+\s*\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}/, "");
};





// add the persona to the userPersonaTypes
const handleSaveAddPersona = async (
  user,
  userPersonaTypes,
  selectedPersona,
  isCopied=false
) => {
  let newPersonaCreationTime = new Date().toISOString().split('.')[0];
  let samePersonaExistList = userPersonaTypes.filter(item => {
    let temp_selectedPersonaVal = selectedPersona.optionValue?.split('_')[0]
    return item.optionValue.includes(temp_selectedPersonaVal)
  })
  let samePersonaTypeExistCount = samePersonaExistList.length;
  let newPersonaTypes = [...userPersonaTypes, selectedPersona];

  if (samePersonaTypeExistCount >= 1) {
    newPersonaTypes = [
      ...userPersonaTypes,
      {
        "optionName": `Untitled`,
        "optionValue":`${selectedPersona['optionValue']?.split('_')[0]}_${samePersonaTypeExistCount+1}___${newPersonaCreationTime}`
      }
    ]
  }
  newPersonaTypes = newPersonaTypes.filter(item =>item);

  console.log("selectedPersona", selectedPersona);
  console.log("newPersonaTypes", newPersonaTypes);
  console.log("userPersonaTypes", userPersonaTypes);

  // change textuser-prod to user

  try {
    // get the default property of the newPersona add default properties of new persona to userNudgeData as a new db node
    const selectedPersonaDefaultData = await get(
      child(ref(defaultNudgeDb), `dashboard-prod/customise_nudge/${selectedPersona.optionValue?.split('_')[0]}`)
    );
    const selectedPersonaDefaultDataObj = selectedPersonaDefaultData.val()
    // only works for exploratory persona nudge as of now
    // console.log(selectedPersonaDefaultData.exists()) // [false, true]
    // console.log(selectedPersonaDefaultDataObj) // [null, {having nudge default data}]
    if (selectedPersonaDefaultData.exists()) {
      await set(
        ref(db, `${user}/customise_nudge/userPersonaTypes`),
        newPersonaTypes
      );

      let newPessonaDbName = selectedPersona.optionValue;
      if (samePersonaTypeExistCount >= 1) {
         newPessonaDbName = `${newPessonaDbName?.split('_')[0]}_${samePersonaTypeExistCount+1}___${newPersonaCreationTime}`
      }
      console.log("-----newPessonaDbName-----", newPessonaDbName)
      if (isCopied) {
        const selectedUserPersonaDBData = await get(
          child(ref(db), `${user}/customise_nudge/userNudgeData/${selectedPersona.optionValue}`)
        );
        if (selectedUserPersonaDBData.exists()) {
          await set(ref(db, `${user}/customise_nudge/userNudgeData/${newPessonaDbName}`), selectedUserPersonaDBData.val());
          handleToast("success", "Added Successfully!");

        } else {
          handleToast("error", "Nudge data not found in DB!");
        }
      } else {
        await set(ref(db, `${user}/customise_nudge/userNudgeData/${newPessonaDbName}`), selectedPersonaDefaultDataObj);
        handleToast("success", "Added Successfully!");

      }
    } else {
      handleToast("error", "cannot add this persona!");
    }
  } catch (error) {
    handleToast("error", "Try after sometimes!");
  }
};







// delete the persona to the userPersonaTypes
const handleSaveDeletePersona = async (
  user,
  userPersonaTypes,
  selectedPersona
) => {
  const newPersonaTypes = userPersonaTypes.filter(
    (persona) => persona.optionValue !== selectedPersona.optionValue
  );

  console.log("selectedPersona", selectedPersona);
  console.log("newPersonaTypes", newPersonaTypes);
  // change textuser-prod to user

  try {
    // set the newPersonaTypes to the userPersonaTypes
    await set(
      // ref(testDb, "testuser-prod/customise_nudge/userPersonaTypes"),
      ref(db, `${user}/customise_nudge/userPersonaTypes`),
      newPersonaTypes
    );
    await set(
      // ref(
      //   testDb,
      //   `testuser-prod/customise_nudge/userNudgeData/${selectedPersona.optionValue}`
      // ),
      ref(
        db,
        `${user}/customise_nudge/userNudgeData/${selectedPersona.optionValue}`
      ),
      null
    );
    handleToast("success", "Deleted Successfully!");
  } catch (error) {
    handleToast("error", "Failed to Delete!");
  }
};








// this function used to set the default nudge to the database
const handleSaveDefaultToDb = async(user) => {
  //add the default nudge to the database
  set(
    // ref(defaultNudgeDb, "dashboard-prod/customise_nudge/upsell2PersonaNudge"), 
    // ref(db, "dashboard-prod/customise_nudge/upsell2PersonaNudge"), 
    ref(db, `${user}/customise_nudge/upsell2PersonaNudge`), 
    OPTIONS.secondUpsellNudge
  ).then(() => {
    handleToast("success", "Saved Successfully exploratoryPersonaNudge");
  });
};

export {
  handleSaveFirstTimeNudge,
  getNudgeData,
  handleSaveAddPersona,
  handleSaveDefaultToDb,
  handleSaveDeletePersona,
  handleSaveReturningNudge,
  handleSaveBannerInHtmlNudge,
};
